<template>
  <b-button type="button" :variant="variant" :id="`resBtn`+suffix+id" :to="to" v-if="show">
    <slot />
  </b-button>
</template>

<script>
export default {
  props: {
    variant: {
      type: String,
      default: 'primary'
    },
    suffix: {
      type: String,
      default: ''
    },
    id: {
      type: [String, Number],
      default: '0'
    },
    to: {
      type: String,
      default: null
    },
    show: {
      type: Boolean,
      default: true
    },
  },
}
</script>
